// const isTest = process.env.NODE_ENV === 'development'
import TVActivate from './activate'
import TVDevices from './devices'

export const TvRoutes = {
  activate: TVActivate,
  devices: TVDevices
}
